import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import VideocamIcon from '@mui/icons-material/Videocam';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CodeIcon from '@mui/icons-material/Code';
import { IconButton } from '@mui/material';

export default function History() {


    const { getHistoryOfUser } = useContext(AuthContext);

    const [meetings, setMeetings] = useState([])


    const routeTo = useNavigate();

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const history = await getHistoryOfUser();
                setMeetings(history);
            } catch {
                // IMPLEMENT SNACKBAR
            }
        }

        fetchHistory();
    }, [])

    let formatDate = (dateString) => {

        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear();

        return `${day}/${month}/${year}`

    }

    return (
        <div className="history-page">
            <nav className="history-navbar">
                <div className="history-navbar-container">
                    <div className="history-navbar-logo">
                        <VideocamIcon style={{ fontSize: '2rem', color: '#6B8E23' }} />
                        <span>Meeting History</span>
                    </div>
                    <button className="history-home-btn" onClick={() => routeTo("/home")}>
                        <HomeIcon />
                        <span>Back to Home</span>
                    </button>
                </div>
            </nav>

            <div className="history-container">
                <div className="history-header">
                    <h1 className="history-title">Your Meeting History</h1>
                    <p className="history-subtitle">View all your past video meetings</p>
                </div>

                <div className="history-grid">
                    {
                        (meetings.length !== 0) ? meetings.map((e, i) => {
                            return (
                                <Card key={i} className="history-card">
                                    <CardContent className="history-card-content">
                                        <div className="history-card-icon">
                                            <VideocamIcon />
                                        </div>
                                        <div className="history-card-info">
                                            <div className="history-info-item">
                                                <CodeIcon className="history-info-icon" />
                                                <div>
                                                    <Typography className="history-info-label">Meeting Code</Typography>
                                                    <Typography className="history-info-value">{e.meetingCode}</Typography>
                                                </div>
                                            </div>
                                            <div className="history-info-item">
                                                <CalendarTodayIcon className="history-info-icon" />
                                                <div>
                                                    <Typography className="history-info-label">Date</Typography>
                                                    <Typography className="history-info-value">{formatDate(e.date)}</Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            )
                        }) : (
                            <div className="history-empty">
                                <VideocamIcon className="history-empty-icon" />
                                <h3>No Meeting History</h3>
                                <p>Your meeting history will appear here once you join or create meetings</p>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}